module.exports = __webpack_public_path__ + "img/Intro-Widgets.be5e1900.png";